import React from 'react';
import HeaderWithoutAuth from '../header-without-auth/header-without-auth';
import FooterWithoutAuth from '../footer-without-auth/footer-without-auth';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import { LoadingGif } from 'components';

const LayoutWithoutAuth = ({ children, ...rest }) => {
  const {loading} = useSelector(state=>state.loader);
  return (
    <div {...rest}>
      <HeaderWithoutAuth />
      <Spin  spinning={loading}    indicator={<LoadingGif></LoadingGif>}  >{children}</Spin> 
      <FooterWithoutAuth />
    </div>
  );
};

export default LayoutWithoutAuth;
